import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  CreateMonitoringSystemUserProps,
  UpdateMonitoringSystemUserProps,
  DeleteMonitoringSystemUserProps,
} from 'entities/MonitoringSystemUser';

import * as service from 'services/monitoring_system_user.service';

export const createMonitoringSystemUser = createAsyncThunk(
  `monitoringSystemUser/create`,
  async (data: CreateMonitoringSystemUserProps, thunkApi) => {
    try {
      const response = await service.createMonitoringSystemUserService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateMonitoringSystemUser = createAsyncThunk(
  `monitoringSystemUser/update`,
  async (data: UpdateMonitoringSystemUserProps, thunkApi) => {
    try {
      const response = await service.updateMonitoringSystemUserService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getMonitoringSystemUserList = createAsyncThunk(
  'monitoringSystemUser/list',
  async (_, thunkApi) => {
    try {
      const response = await service.getMonitoringSystemUserListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const deleteMonitoringSystemUser = createAsyncThunk(
  'monitoringSystemUser/delete',
  async (data: DeleteMonitoringSystemUserProps, thunkApi) => {
    try {
      const response = await service.deleteMonitoringSystemUserService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
